import React from 'react';
import MarketingLayout from '../components/MarketingLayout';

const termsSections = [
  {
    title: '1. Acceptance of Terms',
    content:
      'By using the Better Husband application ("App"), you agree to be bound by these Terms of Service. If you do not accept these terms, do not use the App.',
  },
  {
    title: '2. Service Description',
    content:
      'Better Husband is an application designed to help users improve their relationships through personalized AI-generated suggestions. The App offers:',
    list: [
      'Personalized daily suggestions',
      'Notes and journal features',
      'Event management and reminders',
      'Statistics and progress tracking',
    ],
  },
  {
    title: '3. User Account',
    content:
      'To use the App, you must create an account by providing accurate and complete information. You are responsible for:',
    list: [
      'Maintaining the confidentiality of your credentials',
      'All activities that occur under your account',
      'Notifying us immediately of any unauthorized use',
    ],
  },
  {
    title: '4. Lifetime Access',
    content:
      'Access to app features requires purchasing lifetime access: a single one-time payment, with no subscription and no automatic renewal. There is nothing to cancel. Prices may vary by region and currency. Subscriptions started before the move to lifetime access remain valid on their original terms until they expire or are cancelled.',
  },
  {
    title: '5. User Content',
    content:
      'You retain ownership of all content you create in the App (notes, feedback, etc.). You grant Better Husband a limited license to use this content to provide and improve the service.',
  },
  {
    title: '6. Acceptable Use',
    content: 'You agree not to:',
    list: [
      'Use the App for illegal purposes',
      'Attempt to access other users\' accounts',
      'Interfere with the App\'s operation',
      'Use the App to harass or harm others',
    ],
  },
  {
    title: '7. AI Limitations',
    content:
      'AI-generated suggestions are intended as general guidance and do not replace professional advice. We do not guarantee that suggestions are suitable for your specific situation. For serious relationship issues, we recommend consulting a professional.',
  },
  {
    title: '8. Limitation of Liability',
    content:
      'The App is provided "as is" without warranties of any kind. We are not liable for indirect, incidental, or consequential damages arising from use of the App.',
  },
  {
    title: '9. Changes to Terms',
    content:
      'We may modify these terms at any time. Changes will be effective upon posting in the App. Continued use of the App after changes constitutes acceptance of the new terms.',
  },
  {
    title: '10. Governing Law',
    content:
      'These terms are governed by Italian law. Any disputes shall be subject to the exclusive jurisdiction of Italian courts.',
  },
  {
    title: '11. Contact',
    content:
      'For questions about the Terms of Service, contact us at: support.betterhusband@gmail.com',
  },
];

const LandingTerms = () => {
  return (
    <MarketingLayout>
      <main className="bh-container" style={{ paddingTop: 64, paddingBottom: 96, flex: 1 }}>
        <div style={{ maxWidth: 'var(--measure)', margin: '0 auto' }}>
          <span className="bh-eyebrow">Legal</span>
          <h1 style={{ fontSize: 'clamp(2.2rem, 4vw, 3rem)', marginBottom: 8 }}>Terms &amp; Conditions</h1>
          <p style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 48 }}>Last updated: January 2, 2025</p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 36 }}>
            {termsSections.map((section, index) => (
              <div key={index}>
                <h2 style={{ fontSize: '1.3rem', marginBottom: 10 }}>{section.title}</h2>
                <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>{section.content}</p>
                {section.list && (
                  <ul style={{ marginTop: 12, paddingLeft: 4, listStyle: 'none' }}>
                    {section.list.map((item, i) => (
                      <li key={i} style={{ display: 'flex', gap: 12, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 8 }}>
                        <span style={{ color: 'var(--terracotta)' }}>•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
    </MarketingLayout>
  );
};

export default LandingTerms;
